// src/utils/lastAction.ts
type LastActionKey = "attachment:delete" | "attachment:upload" | string;

type LastAction = {
  key: LastActionKey;
  ts: number;
};

const TTL_MS_DEFAULT: number = Number(
  (import.meta as any)?.env?.VITE_APP_WS_GUARD_TTL_MS ?? 5000,
);
let lastAction: LastAction | null = null;

export const setLastAction = (key: LastActionKey, now = Date.now()) => {
  lastAction = { key, ts: now };
};

export const clearLastAction = () => {
  lastAction = null;
};

export const isRecentAction = (
  key: LastActionKey,
  ttlMs: number = TTL_MS_DEFAULT,
) => {
  if (!lastAction) return false;
  const age = Date.now() - lastAction.ts;
  return lastAction.key === key && age <= ttlMs;
};

export const runWithLastAction = async <T>(
  key: LastActionKey,
  fn: () => Promise<T>,
  ttlMs = TTL_MS_DEFAULT,
): Promise<T> => {
  setLastAction(key);
  try {
    return await fn();
  } finally {
    setTimeout(clearLastAction, ttlMs);
  }
};
